import React from 'react';
import { HomeIcon, GridIcon, MessageIcon, UserIcon } from './Icons';

// Bottom Navigation Component
export const BottomNavigation = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'home', label: 'Accueil', icon: HomeIcon },
    { id: 'categories', label: 'Catégories', icon: GridIcon },
    { id: 'messages', label: 'Messages', icon: MessageIcon },
    { id: 'profile', label: 'Profil', icon: UserIcon }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex">
        {tabs.map(tab => {
          const IconComponent = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex-1 py-3 px-2 flex flex-col items-center justify-center ${
                activeTab === tab.id ? 'text-blue-600' : 'text-gray-500'
              }`}
            >
              <IconComponent />
              <span className="text-xs mt-1">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
